"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPropertiesSchema = exports.createDataSchema = exports.createWeakDataRef = exports.createDataRef = void 0;
var yup_1 = require("yup");
var thunderbolt_becky_types_1 = require("@wix/thunderbolt-becky-types");
var Core_schema_1 = require("./Core.schema");
thunderbolt_becky_types_1.enrich(yup_1.object);
exports.createDataRef = function (schemas) { return yup_1.string().meta({ schemas: schemas }); };
exports.createWeakDataRef = function (schemaType) {
    return yup_1.string().meta({ schemaType: schemaType, weakRef: true });
};
var createSchema = function (type, schema) {
    var baseSchema = yup_1.object({
        id: yup_1.string().required(),
        type: yup_1.mixed()
            .oneOf([type])
            .default(type),
    });
    return schema.concat(baseSchema);
};
exports.createDataSchema = createSchema;
exports.createPropertiesSchema = function (type, schema) {
    return createSchema(type, schema).concat(Core_schema_1.defaultProperties);
};
//# sourceMappingURL=schemaUtils.js.map